module.exports = __webpack_public_path__ + "static/media/bottomCaroDot.1773a68b.png";